import Backbone from 'backbone';
import Model from './InterfaceFinishedModel';
import Globals from '../../../utils/Globals';

const Collection = Backbone.Collection.extend({
    url: Globals.baseUrl + 'interfaces/finished',
    model: Model
});
export default Collection;
